export default __webpack_public_path__ + "static/media/BBB_circle.3a5e43cc.svg";